import { render, staticRenderFns } from "./BookCard.vue?vue&type=template&id=228ca0c9&scoped=true"
import script from "./BookCard.vue?vue&type=script&lang=js"
export * from "./BookCard.vue?vue&type=script&lang=js"
import style0 from "./BookCard.vue?vue&type=style&index=0&id=228ca0c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ca0c9",
  null
  
)

export default component.exports